import { render, staticRenderFns } from "./PaymentPanelConfig.vue?vue&type=template&id=9c63757a&scoped=true"
import script from "./PaymentPanelConfig.vue?vue&type=script&lang=js"
export * from "./PaymentPanelConfig.vue?vue&type=script&lang=js"
import style0 from "./PaymentPanelConfig.vue?vue&type=style&index=0&id=9c63757a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c63757a",
  null
  
)

export default component.exports